﻿import * as Common from '@/tenant/common';

export class StockRelocation extends Common.StateObject{
  constructor(){
    super('StockRelocation');
    this.binders.segment = new Common.ModelBinder(Common.Segment);
    this.binders.warehouseOut = new Common.ModelBinder(Common.Counterpart);
    this.binders.warehouseIn = new Common.ModelBinder(Common.Counterpart);
    this.workflowCode="stockRelocation";
    this.state = StockRelocationStatus.PostWaiting;
    this.workflowStateId = StockRelocationStatus.PostWaiting;
  }
  public get actionTooltip() {
    if (this.state == StockRelocationStatus.PostWaiting)　return '在庫に反映させる場合は【確定】をクリックします。';
    else if (this.state == StockRelocationStatus.Completed) return '内容を修正する場合は【確定取消】をクリックします。';     
    else return '';
  }  
  public stockRelocationNo: string = '';
  public segmentId: number = 0;
  public segment: Common.Segment = null;
  public pic: string = null;
  public refNo: string = null;
  public bookDate: Date = new Date().getCalendarDate();
  public warehouseOutId: number = 0;
  public warehouseOut: Common.Counterpart = null;
  public warehouseInId: number = 0;
  public warehouseIn: Common.Counterpart = null;
}

export enum StockRelocationStatus
{
  PostWaiting = 1, // 確定待ち
  Completed = 2, // 完了
  Instruction = 4 // 移動指示中
}

export class StockRelocationQuery extends Common.LoadQuery {
  constructor(){
    super('StockRelocationQuery',StockRelocation);
    this.sort = 'stockRelocationNo';
  }

  public segment: Common.Segment = null;
  public warehouseOut: Common.Counterpart = null;
  public warehouseIn: Common.Counterpart = null;
  public pic: string = "";
  public stockRelocationNo: string = "";
  public refNo: string = '';
  public bookDateFrom: Date = null;
  public bookDateTo: Date = null;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.StockRelocationStatus = Common.StockRelocationStatus.PostWaiting;
  public holder: string = "";
}

export class GetStockRelocationItemQuery extends Common.Query{
  constructor(){
    super('GetStockRelocationItemQuery', new Common.ModelBinder(Common.StockRelocationItem, true));
  }
  public stockRelocationNo: string = '';
}